import create from '@verndale/core';
import global from './modules/global';

const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { render } = require('react-dom');

  nodeList.forEach((node) => render(<Component {...node.dataset} />, node));
};

const modules = [
  {
    name: 'OstomyLearningCenter',
    loader: () => import('./modules/OstomyLearningCenter'),
  },
  {
    name: 'SplashForm',
    loader: () => import('./modules/SplashForm'),
  },
  {
    name: 'PopupForm',
    loader: () => import('./modules/PopupForm'),
  },
  {
    name: 'GeolocationModal',
    loader: () => import('./modules/GeolocationModal'),
  },
  {
    name: 'ProductDetailModal',
    loader: () => import('./modules/ProductDetailModal'),
  },
  {
    name: 'searchResults',
    loader: () => import('./modules/searchResults'),
    render: reactModule,
  },
  {
    name: 'CeraplusSteps',
    loader: () => import('./modules/CeraplusSteps'),
  },
  {
    name: 'SingleLineQuestion',
    loader: () => import('./modules/SingleLineQuestion'),
  },
  {
    name: 'CeraplusSingleSelect',
    loader: () => import('./modules/CeraplusSingleSelect'),
  },
  {
    name: 'Checkout',
    loader: () => import('./modules/Checkout'),
  },
  {
    name: 'CardCarousel',
    loader: () => import('./modules/CardCarousel'),
  },
  {
    name: 'AccessoriesCard',
    loader: () => import('./modules/AccessoriesCard'),
  },
  {
    name: 'ProductGallery',
    loader: () => import('./modules/ProductGallery')
  },
  {
    name: 'AccordionList',
    loader: () => import('./modules/AccordionList')
  },
  {
    name: 'ContentVideo',
    loader: () => import('./modules/ContentVideo')
  },
  {
    name: 'ProductSample',
    loader: () => import('./modules/ProductSample'),
  },
  {
    name: 'MobileHeader',
    loader: () => import('./modules/global/MobileHeader')
  },
  {
    name: 'DesktopHeader',
    loader: () => import('./modules/global/DesktopHeader')
  },
  {
    name: 'Cart',
    loader: () => import('./modules/global/Cart'),
  },
  {
    name: 'AccessoriesCard',
    loader: () => import('./modules/AccessoriesCard')
  },
  {
    name: 'LoginForm',
    loader: () => import('./modules/LoginForm')
  },
  {
    name: 'ProductAccordion',
    loader: () => import('./modules/ProductAccordion')
  }
];

window.addEventListener('DOMContentLoaded', () => {
  global();
  create(modules);
});
